export const MEASUREMENT_REPORT_DOWNLOAD_ERROR_MESSAGE_KEY = "messages.pdfDownloadFailedRetry"
